import { StatelessComponent } from 'react'
import { SECTION_EXPAND_PX } from 'components/atoms/charts/PieChart'
import { getRGBFromHex } from 'helpers/styleHelpers'
import * as styles from 'styles/atoms/charts/PieChartPlaceholder.css'

type PieChartPlaceholderProps = {
  size: number
  color: string
}

const OPACITY = 0.3

const PieChartPlaceholder: StatelessComponent<PieChartPlaceholderProps> = (props) => {
  const { color, size, children } = props
  const center = size / 2
  const fillColorsRGB = getRGBFromHex(color)
  const fillColor = `rgba(${ fillColorsRGB.join(',') }, ${ OPACITY })`
  const viewboxSize = size + SECTION_EXPAND_PX * 2

  return (
    <div className={ styles.pieChartPlaceholder }>
      <svg viewBox={ `0 0 ${ viewboxSize } ${ viewboxSize }` }>
        <g transform={ `translate(${ SECTION_EXPAND_PX }, ${ SECTION_EXPAND_PX })` }>
          <ellipse fill={ fillColor } cx={ center } cy={ center } rx={ center } ry={ center } />
        </g>
      </svg>
      <div className={ styles.label }>
        { children }
      </div>
    </div>
  )
}

export default PieChartPlaceholder
